import  { useContext } from 'react';
import BioContext from '../../store/bio-context';
import ThemeContext from '../../store/theme-context';
import Projects from './Projects';
const AllProjects = () => {
    const profileInfo = useContext(BioContext);
    const theme = useContext(ThemeContext);
    const projects = [...profileInfo.Projects];
    return ( 
        <div style={{background: theme.currentTheme.background, color: theme.currentTheme.foreground}}>
            <h2 className="screenHeading">PROJECTS</h2>
            {projects && <Projects projects={projects}/> }
        </div>
        
     );
}
 
export default AllProjects;